import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import AuthGuard from "./components/AuthGuard";
import Layout from "./components/Layout";
import Design from "./doc/Design";
import FileListDemo from "./pages/FileListDemo";
import Files from "./pages/Files";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Test from "./pages/Test";
import Upload from "./pages/Upload";
import { Video } from "./pages/Video";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/upload" element={
                        <AuthGuard>
                            <Upload/>
                        </AuthGuard>
                    }/>
                    <Route path="/test" element={<Test/>}/>
                    <Route path="/files" element={
                        <AuthGuard>
                            <Files/>
                        </AuthGuard>
                    }/>
                    <Route path="/demo" element={<FileListDemo/>}/>
                    <Route path="/design" element={<Design/>}/>
                    <Route path="/video/:key" element={
                        <AuthGuard>
                            <Video/>
                        </AuthGuard>
                    }/>
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
